import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export interface AuthState {
  auth: {};
  isLogin:boolean,
  isLoginDummy:boolean,
  path:any

}

const initialState: AuthState = {
  auth: "",
  isLogin:true,
  isLoginDummy:true,
   path: window.location.pathname.slice(1)
  
  

};
// const loginCall = ({email}) => {
//   const response = await axios.get(`http://localhost:9595/sendMailPin`, {
//     api_key:api_key,
//     email:email
//   });
//   return response.data;
// });

export const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    login: (state, { payload: payload }) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes

      state.auth = { ...payload.user };
      // state.auth = { ...state, token: "token" };
      const now = new Date();
      let item = {
        expiry: now.getTime() + 3600000,
        token: payload.user.token,
      };
      sessionStorage.setItem("isLoggedIn", JSON.stringify(item));
      sessionStorage.setItem("userid", payload.user.user_id);
      state.isLogin=true
     


    },
    logout: (state) => {
      state.auth = [];
      sessionStorage.clear();
      state.isLogin=false

    },
    updateLogStatus: (state,action) => {
      
      state.isLogin= !state.isLogin
      state.isLoginDummy= action.payload

    },
    updatePath: (state,action) => {
      
      state.path= action.payload
      

    },
  },
});

// Action creators are generated for each case reducer function
export const { login, logout ,updateLogStatus,updatePath} = authSlice.actions;

export default authSlice.reducer;
